export default __webpack_public_path__ + "static/testimonialOvalBottom-b8b953599f95dd896bd40b4ede130e1b.png";